export enum AssociationType
{
    DO,
    VD,
    GPD
}